<template>
  <div>
    <template v-for="entry, index in data">
      <p :key="index">
	<strong :style="{ color: entry.color }">{{ entry.label }}</strong>
	<dl>
	  <template v-for="item, index in entry.items">
	    <dt><strong>{{ item.code }}</strong></dt>
	    <dd>{{ item.labels[locale] }}</dd>
	  </template>
	</dl>
      </p>
    </template>
  </div>
</template>

<script>
 import localeMixin from '@/mixins/locale.js'

 export default {
   mixins: [localeMixin],
   props: {
     data: {
       type: Array,
       default: () => []
     }
   }
 }
</script>
